/**
 * 分区计量模块 · 第 4 组（src/views/DMAPartitionMetering/PipelineNew 其余页面）英文映射
 * 中文原文做 key，value 为英文译文；与其他 en/modules/*.js 由 src/i18n/index.js 自动合并
 */
export default {
  // ── 通用（复用全局词条，同 en-US.js / 其他 en/modules/*.js）──
  '确定': 'OK',
  '取消': 'Cancel',
  '关闭': 'Close',
  '查询': 'Query',
  '重置': 'Reset',
  '新增': 'Add',
  '删除': 'Delete',
  '编辑': 'Edit',
  '详情': 'Details',
  '操作': 'Action',
  '其他': 'Other',
  '保存': 'Save',
  '下载': 'Download',
  '无图片': 'No Image',
  '无文件': 'No File',
  '序号': 'No.',
  '时间': 'Time',
  '日期': 'Date',
  '月份': 'Month',
  '用户编号': 'Customer No.',
  '用户名称': 'Customer Name',
  '表编号': 'Meter No.',

  // ── 营收反查 RevenueCounterCheck ──
  '请选择月份': 'Please select month',
  '上次抄读时间': 'Last Reading Time',
  '本次抄读时间': 'Current Reading Time',
  '抄表天数': 'Reading Interval (days)',
  '上次抄表读数': 'Last Reading',
  '本次抄表读数': 'Current Reading',
  '本月用水量': 'Consumption This Month',
  '上月用水量': 'Consumption Last Month',

  // ── 小区治理 CommunityGovernance ──
  '排名': 'Rank',
  '分区名称': 'District Name',
  '小区名称': 'Community Name',
  '总分差水量(m³)': 'Main-Sub Meter Difference Volume (m³)',
  '总分表差率(%)': 'Main-Sub Meter Difference Rate (%)',
  '上月总分差(m³)': 'Last Month Main-Sub Difference (m³)',
  '环比率(%)': 'Month-on-Month Rate (%)',
  '治理意见': 'Governance Suggestion',
  '发起时间': 'Initiated At',
  '物理漏损': 'Physical Leakage',
  '管理漏损': 'Management Leakage',
  '总表水量(m³)': 'Main Meter Volume (m³)',
  '分表水量(m³)': 'Sub Meter Volume (m³)',
  '用户数': 'Number of Customers',
  '抄见率(%)': 'Meter Reading Rate (%)',
  '合理夜间最小水量(m³)': 'Reasonable Minimum Night Volume (m³)',
  '平均夜间最小水量(m³)': 'Average Minimum Night Volume (m³)',
  'KL值': 'KL Value',
  '发起整治': 'Initiate Governance',
  '发起治理成功': 'Governance initiated successfully',
  '获取数据失败': 'Failed to get data',

  // ── 进出水分析 InletAndOutletWaterAnalysis ──
  '区域&流量计信息': 'Area & Flow Meter Info',
  '区域名称': 'Area Name',
  '片区编码': 'Area Code',
  '分区级别': 'District Level',
  '区域面积(m³)': 'Area (m³)',
  '已绑定流量计': 'Bound Flow Meters',
  '请先在左侧选择区域': 'Please select an area on the left first',
  '开始日期': 'Start Date',
  '结束日期': 'End Date',
  '名称': 'Name',
  '节点编码': 'Node Code',
  '物联设备id': 'IoT Device ID',
  '转换系数': 'Conversion Coefficient',
  '区域供水量m³': 'Area Supply Volume m³',
  '区域用水量（m³）': 'Area Consumption (m³)',
  '居民用水量m³': 'Residential Consumption m³',
  '基础漏损率%': 'Base Leakage Rate %',
  '最终漏损率%': 'Final Leakage Rate %',
  '抄表修正率%': 'Meter Reading Correction Rate %',
  '水管修正值%': 'Pipe Correction Value %',
  '管压修正率%': 'Pipe Pressure Correction Rate %',
  '冻土修正率%': 'Frozen Soil Correction Rate %',
  '日期最大范围为60天': 'The maximum date range is 60 days',

  // ── 最小流量分析 MinimumFlowAnalysis ──
  '请选择日期': 'Please select date',
  '物联设备': 'IoT Device',
  '节点编号': 'Node No.',
  '今日最小瞬时(m³/h)': "Today's Minimum Instantaneous Flow (m³/h)",
  '昨日最小瞬时(m³/h)': "Yesterday's Minimum Instantaneous Flow (m³/h)",
  '数值': 'Value',
  '建议意见': 'Suggestion',
  '差值(m³/h)': 'Difference (m³/h)',
  '获取数据失败，请稍后重试': 'Failed to get data, please try again later',

  // ── 供水量分析 WaterSupplyAnalysis ──
  '累计用量(m³)': 'Cumulative Usage (m³)',

  // ── 最小流量分析详情 MinimumFlowAnalysisModal ──
  '起止日期': 'Date Range',
  '请选择起止日期': 'Please select date range',
  '夜间最小流量': 'Minimum Night Flow',
  '出现时间': 'Occurrence Time',
  '最小瞬时(m³/h)': 'Minimum Instantaneous Flow (m³/h)',
  '最大瞬时(m³/h)': 'Maximum Instantaneous Flow (m³/h)',
  '平均水量(m³/h)': 'Average Flow (m³/h)',
  '夜间最小流量占比(%)': 'Minimum Night Flow Ratio (%)',
  '最小瞬时': 'Minimum Instantaneous Flow',
  '最大瞬时': 'Maximum Instantaneous Flow',
  '平均水量': 'Average Flow',
  '夜间最小流量占比': 'Minimum Night Flow Ratio',
  '最小流量分析': 'Minimum Flow Analysis',
  '最小流量分析详情': 'Minimum Flow Analysis Details',

  // ── 最小流量配置 MinimumFlowConfiguration / model1~3 ──
  '夜间时段选择': 'Night Time Period Selection',
  '夜间时段': 'Night Time Period',
  '开始时间': 'Start Time',
  '结束时间': 'End Time',
  '选择时间范围': 'Select time range',
  '连续异常天数': 'Consecutive Abnormal Days',
  '合法用水系数设定': 'Legal Use Coefficient Settings',
  '最小流量异常设定': 'Minimum Flow Abnormality Settings',
  '建议意见设定': 'Suggestion Settings',
  '居民类型': 'Resident Type',
  '合法用水系数': 'Legal Use Coefficient',
  '设置类型': 'Setting Type',
  '分区通用设置': 'District Common Setting',
  '分区独立设置': 'District Independent Setting',
  '流量区间最小值': 'Minimum Flow Interval',
  '流量区间最大值': 'Maximum Flow Interval',
  '数字符号': 'Numeric Symbol',
  '变化幅度(%)': 'Change Amplitude (%)',
  '报警颜色': 'Alarm Color',
  '异常/连接异常': 'Abnormal/Connection Abnormal',
  '区间': 'Interval',
  '颜色': 'Color',
  '民用': 'Residential',
  '商用': 'Commercial',
  '机关团体': 'Government/Institution',
  '异常': 'Abnormal',
  '连接异常': 'Connection Abnormal',
  '建议1': 'Suggestion 1',
  '建议2': 'Suggestion 2',
  '建议3': 'Suggestion 3',
  '请选择完整的时间范围': 'Please select a complete time range',
  '获取字典项失败': 'Failed to get dictionary items',
  '没有找到需要更新的字典项，请先在系统字典管理中创建相关字典项': 'No dictionary items found to update. Please create the related dictionary items in system dictionary management first',
  '保存成功': 'Saved successfully',
  '部分保存失败，请检查数据': 'Some items failed to save, please check the data',
  '保存失败': 'Save failed',
  '请选择居民类型': 'Please select resident type',
  '请输入合法用水系数': 'Please enter legal use coefficient',
  '请输入流量区间最小值': 'Please enter minimum flow interval',
  '请输入流量区间最大值': 'Please enter maximum flow interval',
  '请选择数字符号': 'Please select numeric symbol',
  '请输入变化幅度': 'Please enter change amplitude',
  '请输入异常/连接异常': 'Please enter abnormal/connection abnormal',
  '请输入KL值': 'Please enter KL value',
  '请输入区间': 'Please enter interval',
  '请输入建议意见': 'Please enter suggestion',

  // ── 最小流量 MinimumFlowRate ──
  '选择日期': 'Select Date',
  '一级分区名称': 'Level-1 District Name',
  '二级分区流量计': 'Level-2 District Flow Meter',
  '小区流量计': 'Community Flow Meter',
  '总数': 'Total',
  '正常数': 'Normal Count',
  '警告数': 'Warning Count',
  '严重数': 'Critical Count',
  '无效数': 'Invalid Count',
  '未获取到拓扑参数，请先选择拓扑': 'Topology parameters not obtained, please select a topology first',
  '查询失败': 'Query failed',
  '查询异常，请稍后重试': 'Query error, please try again later',

  // ── 在线监控 onlineMonitor / internetTraffic / pressure ──
  '流量': 'Flow',
  '压力': 'Pressure',
  '站点名称': 'Station Name',
  '请输入站点名称': 'Please enter station name',
  '分区编码': 'District Code',
  '节点名称': 'Node Name',
  '物联设备编码': 'IoT Device Code',
  '流量(m³/h)': 'Flow (m³/h)',
  '反向流量(m³/h)': 'Reverse Flow (m³/h)',
  '累计流量(m³)': 'Cumulative Flow (m³)',
  '瞬时流量(m³)': 'Instantaneous Flow (m³)',
  '压力(Mpa)': 'Pressure (MPa)',
  '温度(℃)': 'Temperature (℃)',
  '网络请求失败': 'Network request failed',
  '添加区域功能待实现': 'Add area function not implemented',
  '添加子区域功能待实现': 'Add sub-area function not implemented',
  '删除区域功能待实现': 'Delete area function not implemented',

  // ── 概览组件 component1 ──
  '问题处置': 'Issue Handling',
  '报警': 'Alarm',
  '待处理': 'Pending',
  '已确认': 'Confirmed',
  '已派单': 'Dispatched',
  '基础信息': 'Basic Info',
  '一级分区': 'Level-1 District',
  '分区面积': 'District Area',
  '二级分区': 'Level-2 District',
  '管网长度': 'Pipe Network Length',
  '小区': 'Community',
  '用户数量': 'Number of Customers',
  '个': 'pcs',
  '户': 'Household(s)',
  '设备数量': 'Device Count',
  '分区进出水': 'District Inlet/Outlet',
  '流量监测点': 'Flow Monitoring Point',
  '压力监测点': 'Pressure Monitoring Point',
  '水质监测点': 'Water Quality Monitoring Point',
  '远传大用户': 'Remote Large Customer'
}
